import React from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import { useForceUpdate, numberToLetter } from '../util';
import { Content } from '../DataStructures';
import TaskSlider from '@bittnerdevelopmentgroup/interactive/dist/TaskSlider/TaskSlider';
import { contentIsEmpty } from './TaskMultiChoice';
import { FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
const atLeastOneCorrect = data => {
  for (let i = 0; i < data.length; ++i) {
    if (data[i].correct === true) {
      return true;
    }
  }
  return false;
};
export default function TaskMultiSelectSubmit(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Prompt:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselectsubmit-prompt",
    value: dataProps.prompt,
    onChange: v => {
      dataProps.prompt = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.prompt)
  }, "Question Prompt is empty.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Button Width:")), /*#__PURE__*/React.createElement(TaskSlider, {
    handleChange: value => {
      dataProps.buttonWidth = `${value}px`;
      forceUpdate();
      props.onChanged();
    },
    start: parseInt(dataProps.buttonWidth),
    min: 20,
    max: 200,
    step: 1,
    tooltip: "auto"
  })))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Response Details"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Response:"), " ", /*#__PURE__*/React.createElement("i", null, "Select the correct options.")), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: atLeastOneCorrect(dataProps.data)
  }, "At least one response must be correct"), dataProps.data.map((choice, key) => {
    return /*#__PURE__*/React.createElement(Form.Check, {
      id: "choice-" + key,
      name: "choices"
    }, /*#__PURE__*/React.createElement(Form.Row, {
      className: "align-items-center mb-2"
    }, /*#__PURE__*/React.createElement(Form.Check.Input, {
      type: "checkbox",
      id: "form-input-" + key,
      checked: choice.correct,
      onChange: e => {
        choice.correct = e.target.checked;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(Form.Check.Label, {
      width: "100%"
    }, numberToLetter(key), ":\xA0"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
      value: dataProps.data[key].value,
      inlineOnly: true,
      onChange: v => {
        dataProps.data[key].value = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: !contentIsEmpty(dataProps.data[key].value)
    }, "Question Response is empty.")), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, dataProps.data.length > 1 && /*#__PURE__*/React.createElement(Button, {
      variant: "outline-danger",
      title: "Remove choice",
      onClick: () => {
        dataProps.data.splice(key, 1);
        props.onChanged();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-trash"
    })))));
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    title: "Add new choice",
    onClick: () => {
      dataProps.data.push({
        label: new Content(),
        correct: false
      });
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "2",
    title: "3. Feedback"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-correct",
    value: dataProps.correctFeedback,
    onChange: v => {
      dataProps.correctFeedback = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Incorrect Feedback:")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-incorrect",
    value: dataProps.incorrectFeedback,
    onChange: v => {
      dataProps.incorrectFeedback = v;
      forceUpdate();
      props.onChanged();
    }
  })))));
}